import React, { Component } from 'react';
import './Table.scss';

export default class Table extends Component {
  render() {
    return (
      <table className="form_table">
        <tbody>
        {
          this.props.data.map(i => (
            <tr key={i.id}>
              <td>
                {i.label}
              </td>
              <td>
                {i.value}
              </td>
            </tr>
          ))
        }
        </tbody>
      </table>
    )
  }
}
